import React from "react";
import { Card, CardBody, CardTitle, Row, Col } from "reactstrap";

const SubscriptionsComponent = ({ listData }) => {
  const tableCellStyle = {
    fontSize: "14px",
    color: "#333", // Couleur du texte dans le tableau
    fontFamily: "sans-serif",
  };
  return (
    <>
      {listData.allowed ? (
        <Col>
          <CardTitle className="mb-2" style={{ color: "#3498db" }}>
            {listData.title}
          </CardTitle>{" "}
          <Card className="mini-stats-wid">
            <CardBody>
              <table className="table table-striped">
                <tbody>
                  {listData.data.length > 0 ? (
                    listData.data.map((item, id) => (
                      <tr key={id}>
                        <>
                          <td style={tableCellStyle}>
                            {item.nom_investisseur}{" "}
                          </td>
                          <td style={tableCellStyle}>
                            {item.montant_souscription.toLocaleString("fr-FR", {
                              style: "currency",
                              currency: "EUR", minimumFractionDigits: 0,
                            })}
                          </td>
                          <td style={tableCellStyle}>
                            {item.date_souscription}{" "}
                          </td>
                        </>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={listData.header.length}>
                        Aucune donnée disponible
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </CardBody>
          </Card>
        </Col>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default SubscriptionsComponent;
